// src/client/index.ts
var RELOAD_FLAG = "app-version-reload-at";
var RELOAD_WINDOW_MS = 3e4;
var CHUNK_ERROR = /Loading( CSS)? chunk [\w-]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;
var memoryTs = null;
function readTs() {
  try {
    const v = sessionStorage.getItem(RELOAD_FLAG);
    return v ? Number(v) : memoryTs;
  } catch {
    return memoryTs;
  }
}
function writeTs(ts) {
  memoryTs = ts;
  try {
    sessionStorage.setItem(RELOAD_FLAG, String(ts));
  } catch {
  }
}
function isChunkError(message) {
  return typeof message === "string" && CHUNK_ERROR.test(message);
}
var registered = false;
function registerAppVersionRecovery(options) {
  if (registered) return;
  registered = true;
  const handle = () => {
    const last = readTs();
    const canAutoRefresh = !(last && Date.now() - last < RELOAD_WINDOW_MS);
    options.onDetected({
      reload: () => {
        writeTs(Date.now());
        window.location.reload();
      },
      canAutoRefresh
    });
  };
  window.addEventListener("vite:preloadError", ((event) => {
    event.preventDefault();
    handle();
  }));
  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkError(event.reason?.message ?? event.reason)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handle();
  });
}

export { registerAppVersionRecovery };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map